module.exports = __webpack_public_path__ + "static/img/1.52069c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/1.png
// module id = B9sb
// module chunks = 0